import React, {Component} from 'react';
import { ReactComponent as OpenseaIcon } from "../images/Opensea-white.svg";
import { SiDiscord } from "react-icons/si";
import { SiInstagram } from "react-icons/si";
//import { SiTwitter } from "react-icons/si";
import { SiFacebook } from "react-icons/si";
import { SiPinterest } from "react-icons/si";
import { SiTiktok } from "react-icons/si";
import { SiYoutube } from "react-icons/si";
import { ReactComponent as XIcon } from "../images/x-twitter-white.svg";

class SectionPiedone  extends Component {
    render() {
        const current = new Date();
        /*const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;*/
        let twitter;
        let discord;
        let instagram;
        let facebook;
        let tiktok;
        let pinterest;
        let opensea;
		let youtube;

        if (this.props.piedoneTwitter) {
            twitter = (
                <li className="ftco-animate"><a href={this.props.piedoneTwitter} target="_blank" rel="noreferrer noopener"><span style={{color: "red"}}><XIcon /></span></a></li>
            );
        } else {
            twitter = "";
        }
        if (this.props.piedoneDiscord) {
            discord = (
                <li className="ftco-animate"><a href={this.props.piedoneDiscord} target="_blank" rel="noreferrer noopener"><span><SiDiscord style={{fontSize: '1,5em'}} /></span></a></li> 
            );
        } else {
            discord = "";
        }
        if (this.props.piedoneInstagram) {
            instagram = (
                <li className="ftco-animate"><a href={this.props.piedoneInstagram} target="_blank" rel="noreferrer noopener"><span><SiInstagram style={{fontSize: '1,5em'}} /></span></a></li> 
            );
        } else {
            instagram = "";
        }
        if (this.props.piedonePinterest) {
            pinterest = (
                <li className="ftco-animate"><a href={this.props.piedonePinterest} target="_blank" rel="noreferrer noopener"><span><SiPinterest style={{fontSize: '1,5em'}} /></span></a></li> 
            );
        } else {
            pinterest = "";
        }
        if (this.props.piedoneFacebook) {
            facebook = (
                <li className="ftco-animate"><a href={this.props.piedoneFacebook} target="_blank" rel="noreferrer noopener"><span><SiFacebook style={{fontSize: '1,5em'}} /></span></a></li> 
            );
        } else {
            facebook = "";
        }
        if (this.props.piedoneTiktok) {
            tiktok = (
                <li className="ftco-animate"><a href={this.props.piedoneTiktok} target="_blank" rel="noreferrer noopener"><span><SiTiktok style={{fontSize: '1,5em'}} /></span></a></li>
            );
        } else {
            tiktok = "";
        }
        if (this.props.piedoneOpensea) {
            opensea = (
                <li className="ftco-animate"><a href={this.props.piedoneOpensea} target="_blank" rel="noreferrer noopener"><span style={{color: "red"}}><OpenseaIcon /></span></a></li> 
            );
        } else {
            opensea = "";
        }
        if (this.props.piedoneYoutube) {
            youtube = (
                <li className="ftco-animate"><a href={this.props.piedoneYoutube} target="_blank" rel="noreferrer noopener"><span><SiYoutube style={{fontSize: '1,5em'}} /></span></a></li> 
            );
        } else {
            youtube = "";
        }


        return (
            <section className="ftco-footer ftco-section img">
                <div className="container">
                    <div className="row text-center ftco-animate">
						<div className="col-md-12">
							<div className="ftco-footer-widget ">
								<h2 className="ftco-heading-2">{this.props.piedoneCallToAction}</h2>
							</div>
						</div>
					</div>
                    <div className="row justify-content-center" dangerouslySetInnerHTML={{ __html: this.props.piedoneIframe }}></div>
                    <div className="row justify-content-center">
                        <div className="col-md-8 heading-section text-center ftco-animate">
                            <ul className="ftco-footer-social list-unstyled">
                                {twitter}
                                {discord}   
                                {instagram}
                                {facebook}
                                {tiktok}
                                {pinterest}
                                {opensea}
								{youtube}
                            </ul>
                        </div>
                    </div>
					<div className="row text-center ftco-animate">
						<div className="col-md-12">
							<div className="ftco-footer-widget ">
								<h2 className="ftco-heading-2">Collegamenti</h2>
							</div>
						</div>
					</div>
					<div className="row text-center ftco-animate">
						<div className="col-md-4 text-center">
							<div className="ftco-footer-widget mb-4 ml-md-4">
							<ul className="list-unstyled">	
									<li><a href={this.props.piedoneLinkPrivacy} className="py-0 d-block">Informativa sulla Privacy</a></li>
								</ul>
							</div>
						</div>
						<div className="col-md-4 text-center">
							<div className="ftco-footer-widget mb-4 ml-md-4">
								<ul className="list-unstyled">	
									<li><a href={this.props.piedoneLinkCookies} className="py-0 d-block">Informativa sui Cookies</a></li>
								</ul>
							</div>
						</div>
						<div className="col-md-4 text-center">
							<div className="ftco-footer-widget mb-4 ml-md-4">
							<ul className="list-unstyled">	
									<li><a href={this.props.piedoneEliosfera} className="py-0 d-block" target="_blank"  rel="noreferrer noopener">Pagina del romanzo su Eliosfera Editrice</a></li>
							</ul>			
							</div>
						</div>
					</div>

					<div className="row mt-4 ftco-animate">
                        <div className="col-md-12 text-center">
                            <p>{this.props.piedoneCopyright} {current.getFullYear()} - {this.props.piedoneCopyrightDisclaimer}</p>
                            <p dangerouslySetInnerHTML={{ __html: this.props.piedoneCCBY }}></p>
                        </div>
                    </div>
                </div>
            </section> 
        );
    }
}
export default SectionPiedone;
